module.exports = __webpack_public_path__ + "static/beregnkostnad-ccada3ecf36d635c654ac4f736fa3df5.png";